export const NO_SCRIPT_HTML = '<noscript><link rel="stylesheet" href="/no-script.css"></noscript>'
